// extracted by css-extract-rspack-plugin
export default {"cluster":"cluster-dSgKzI","clickable":"clickable-bEr09F"};